import React from "react";
import PropTypes from "prop-types";

import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterSwitch from "./FilterSwitch";
import { Chip, Stack } from "@mui/material";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  padding: "10px 22px",
  border: "2px solid",
  lineHeight: 1.5,
  backgroundColor: "#fff",
  color: "#637381",
  borderColor: "rgba(145, 158, 171, 0.24)",
  fontFamily: "Poppins",
  fontWeight: 500,
  maxHeight:'52px',
  "&:hover": {
    backgroundColor: "#fff",
    borderColor: "#37B34A",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#fff",
    borderColor: "#37B34AB5",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem #37B34AB5",
  },
});

const Filter = (props) => {
  const {
    buttonName,
    donorFilterObj,
    donorFilter,
    setDonorFilterValue,
    productGroupObj,
    productFilter,
    setProductFilterValue,
    handleChangeFilterType,
    t,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const noOfActiveFilter = React.useMemo(() => {
    const allFilter = { ...donorFilter, ...productFilter };
    const activeFilter = Object.keys(allFilter).filter(
      (p) => allFilter[p] === true
    );
    return activeFilter.length;
  }, [donorFilter, productFilter]);

  return (
    <div>
      <BootstrapButton
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<FilterListIcon />}
      >
        {t(buttonName)}{" "}
        <Chip
          sx={{
            backgroundColor: "#E4F2E8",
            color: "#1B727E",
            m: "5px",
            "& .MuiChip-label": { fontWeight: "bold" },
          }}
          label={noOfActiveFilter}
          size={"medium"}
          component="span"
        />
      </BootstrapButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Stack direction={"row"} alignItems={"flex-start"}>
          <MenuItem disableRipple>
            <FilterSwitch
              filterLabel={"type"}
              filterObject={donorFilterObj}
              filterState={donorFilter}
              setFilterState={setDonorFilterValue}
              handleChangeFilterType = {handleChangeFilterType}
              t={t}
            />
          </MenuItem>
          {productGroupObj !== undefined &&
            ((donorFilter.donor && !donorFilter.event) ||
              (donorFilter.donor && donorFilter.event)) && (
              <MenuItem disableRipple>
                <FilterSwitch
                  filterLabel={"category"}
                  filterObject={productGroupObj}
                  filterState={productFilter}
                  setFilterState={setProductFilterValue}
                  t={t}
                />
              </MenuItem>
            )}
        </Stack>
      </StyledMenu>
    </div>
  );
};

Filter.propTypes = {
  donorFilterObj: PropTypes.object,
  donorFilter: PropTypes.object,
  setDonorFilterValue: PropTypes.func,
  productGroupObj: PropTypes.object,
  productFilter: PropTypes.object,
  setProductFilterValue: PropTypes.func,
  t: PropTypes.func,
};

export default Filter;
